// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8f75e046","977":"b57ef3ef"}[chunkId] + ".chunk.js";
};